import React from "react";
import "./formfieldcomponent.css";
import { Textarea, Text } from "@mantine/core";

interface FormFieldComponentProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (field: string, value: string) => void;
  field: string;
  type: string;
  disabled: boolean;
  classNames?: string;
  maxLength?: number;
}

const FormFieldComponent = ({
  label,
  placeholder,
  value,
  onChange,
  field,
  type,
  disabled,
  maxLength
}: FormFieldComponentProps) => {
  return (
    <>
      {type === "textarea" ? (
        <>
          <Textarea
            w="100%"
            styles={{ root: { display: "block" } }}
            label={label ? label : null}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              if (!maxLength || e.target.value.length <= maxLength) {
                onChange(field, e.target.value);
              }
            }}
            disabled={disabled}
          />
          {maxLength && (
            <Text size="xs" ta="right" c="dimmed">
              {value.length}/{maxLength}
            </Text>
          )}
        </>

      ) : (
        <div className="formfield-container-input">
          {label ? <label>{label}</label> : <></>}
          <input
            className=""
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              if (!maxLength || e.target.value.length <= maxLength) {
                onChange(field, e.target.value);
              }
            }}
            disabled={disabled}
          />
          {maxLength && (
            <Text size="xs" ta="right" c="dimmed">
              {value.length}/{maxLength}
            </Text>
          )}
        </div>
      )}
    </>
  );
};

export default FormFieldComponent;
